import type { FC, PropsWithChildren } from 'react';
import { useCallback, useMemo, useState } from 'react';

import type { BottomModalProps } from '@/features/popup/components/BottomModal';
import { BottomModal } from '@/features/popup/components/BottomModal';
import type { BottomModalContextValues } from '@/features/popup/provider/useBottomModal';
import { BottomModalContext } from '@/features/popup/provider/useBottomModal';

export const BottomModalProvider: FC<PropsWithChildren> = ({ children }) => {
  // Todo: does not work with set state action views
  const [bottomModal, setBottomModal] = useState<
    BottomModalProps | undefined
  >();

  const handleClearBottomModal = useCallback(
    () => setBottomModal(undefined),
    []
  );

  const showBottomModal = useCallback(
    (modal: Omit<BottomModalProps, 'onClose' | 'isVisible'>) =>
      setBottomModal({
        ...modal,
        isVisible: true,
        onClose: handleClearBottomModal
      }),
    [handleClearBottomModal]
  );

  const clearAllBottomModals = useCallback(
    () => handleClearBottomModal(),
    [handleClearBottomModal]
  );

  const values: BottomModalContextValues = useMemo(
    () => ({
      clearAllBottomModals,
      showBottomModal
    }),
    [clearAllBottomModals, showBottomModal]
  );

  return (
    <BottomModalContext.Provider value={values}>
      {children}
      <BottomModal {...bottomModal} />
    </BottomModalContext.Provider>
  );
};
